import React from 'react';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { useTranslations } from '@unisporkal/localization';
import cx from 'classnames';
import styles from './AcquisitionTitle.module.scss';
import { useAcquisitionType } from '../../hooks/stateful/useAcquisitionType';
import acquisitionTypes from '../../support/acquisitionTypes';
import useMode from '../../hooks/stateful/useMode';
import acquisitionMode from '../../support/acquisitionMode';
import SimpleTitleModal from './simpleTitleModal';

interface SimpleTitleProps {
  title: string;
  onBackLinkClick?: () => void;
}

const SimpleTitle: React.FC<SimpleTitleProps> = ({
  title,
  onBackLinkClick,
}) => {
  const { acquisitionType } = useAcquisitionType();
  const { mode } = useMode();
  const t = useTranslations();

  const modifiedModalDownloadCompleted =
    acquisitionType === acquisitionTypes.MODIFIED_DOWNLOAD_COMPLETED &&
    mode === acquisitionMode.MODAL;

  const isTitleCentered =
    acquisitionType === acquisitionTypes.MODIFIED_LICENSE_REDOWNLOAD ||
    acquisitionType === acquisitionTypes.MODIFIED_CART_CONFIRMATION ||
    acquisitionType === acquisitionTypes.MODIFIED_LIMITED_USE_PRODUCTS;

  const backLink = onBackLinkClick ? (
    <div className={styles.downloadOptionsBackLink}>
      <Button
        size={ButtonSizeEnum.EXTRA_SMALL}
        variant={ButtonVariantEnum.LINK}
        onClick={onBackLinkClick}
        data-testid="download-options-back-link"
        className={styles.downloadOptionsBackButton}
      >
        {t('download_options_back')}
      </Button>
    </div>
  ) : null;

  if (modifiedModalDownloadCompleted) {
    return (
      <>
        {backLink}
        <SimpleTitleModal title={title} />
      </>
    );
  }

  return (
    <>
      {backLink}
      <div
        className={cx(
          isTitleCentered
            ? styles.simpleCenteredTitleContainer
            : styles.simpleTitleContainer
        )}
        data-testid="simple-title-container"
      >
        <Typography
          variant={TypographyVariant.body.large}
          component={TypographyComponentEnum.H6}
          className={styles.title}
        >
          {title}
        </Typography>
      </div>
    </>
  );
};

export default SimpleTitle;
